// Re-export shared types from AuditTimelineService and add any view-specific types.
export type {
	AuditEvent,
	ListEventsParams,
	ListEventsResult,
	AuditAdminUser,
} from "../../../services/AuditTimelineService";

export type FilterState = {
	actor_email: string;
	target_type: string;
	action: string;
	app: string;
	severity_min: string;
	since: string;
	until: string;
};

export const EMPTY_FILTERS: FilterState = {
	actor_email: "",
	target_type: "",
	action: "",
	app: "",
	severity_min: "",
	since: "",
	until: "",
};

// ── Archive Search types ───────────────────────────────────────────────────────

export type ArchiveSearchParams = {
	since: string; // ISO date string, required
	until: string; // ISO date string, required
	actor_email?: string;
	action?: string;
	app?: string;
	severity_min?: number;
};

/** Status values returned by GET /api/audit/archive-search/:jobId */
export type ArchiveJobStatus = "pending" | "running" | "done" | "failed";

export type ArchiveSearchJob = {
	jobId: string;
	status: ArchiveJobStatus;
	/** 0–100 progress percentage (approximated from processed_objects / total_objects) */
	progress: number;
	totalObjects: number | null;
	processedObjects: number;
	results: import("../../../services/AuditTimelineService").AuditEvent[] | null;
	errorMessage: string | null;
};

export const EMPTY_ARCHIVE_SEARCH_PARAMS: ArchiveSearchParams = {
	since: "",
	until: "",
	actor_email: "",
	action: "",
	app: "",
};
